import { useSelector } from "react-redux";
import { useApiGet } from "../hooks/useApiHook";
import Checkers from "../helpers/class/Checkers";

interface AppSectionSlotProps {
  position: string
}

export default function AppSectionSlot ( { position }: AppSectionSlotProps ) {

  const pageId = useSelector( state => state['builderSettingsData']['settings']['page_id'] )

  const sections = useApiGet( `/api/lodge/frontend/get/app-sections/${pageId}`, `position=${position}&type=HTML`, false )

  return (
      <>
        {
          sections.status == 200 && Checkers.isValidArray( sections.data.app_sections ) &&
            sections.data.app_sections.map( ( section, index ) => (
                <div key={index} dangerouslySetInnerHTML={{ __html: section.app_section_content }} />
            ) )
        }
      </>
  )
}
